<template>
  <div class="market-trade">
    <LoadingOverlay :show="loading" />
    <!-- 新增余额显示框 -->
    <div class="balance-box">
      <div class="balance-label">Balance:</div>
      <div class="balance-value">{{ userInfo.money || 0.00 }}</div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="d-flex align-items-center mb-3">
          <h5 class="card-title mb-0">{{ bi.ename }}</h5>
          <span class="ms-2 price">{{ curBiPrice }}</span>
        </div>

        <div class="form-group mb-3">
          <select class="form-select" v-model="priceType">
            <option value="Market Price">Market Price</option>
            <option value="Pending Orders">Pending Orders</option>
          </select>
        </div>
        <div class="form-group mb-3" v-show="priceType == 'Pending Orders'">
          <label>Price</label>
          <input type="number" class="form-control" placeholder="Please enter the price" v-model="price" />
        </div>
        <!-- <div class="form-group mb-3">
          <label>Leverage</label>
          <div class="input-group">
            <button class="btn btn-outline-secondary" @click="decreaseLeverage">
              -
            </button>
            <input
              type="number"
              class="form-control text-center"
              v-model="leverage"
            />
            <button class="btn btn-outline-secondary" @click="increaseLeverage">
              +
            </button>
          </div>
        </div> -->

        <div class="form-group mb-3">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <label>Stop Loss</label>
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" role="switch" v-model="stopLossEnabled" />
            </div>
          </div>
          <div class="input-group">
            <button class="btn btn-outline-secondary" @click="decreaseStopLoss">
              -
            </button>
            <input type="number" class="form-control text-center" v-model="stopLoss" :disabled="!stopLossEnabled" />
            <button class="btn btn-outline-secondary" @click="increaseStopLoss">
              +
            </button>
          </div>
        </div>

        <div class="form-group mb-3">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <label>Take Profit</label>
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" v-model="takeProfitEnabled" />
            </div>
          </div>
          <div class="input-group">
            <button class="btn btn-outline-secondary" @click="decreaseTakeProfit" type="button">
              -
            </button>
            <input type="number" class="form-control text-center" v-model="takeProfit" :disabled="!takeProfitEnabled" />
            <button class="btn btn-outline-secondary" @click="increaseTakeProfit">
              +
            </button>
          </div>
        </div>

        <div class="form-group mb-4">
          <label>Amount(Lots)</label>
          <div class="input-group">
            <button class="btn btn-outline-secondary" @click="decreaseAmount">
              -
            </button>
            <input type="number" class="form-control text-center" v-model="amount" step="0.01" />
            <button class="btn btn-outline-secondary" @click="increaseAmount">
              +
            </button>
          </div>
        </div>

        <div class="trade-info mb-4">
          <div class="info-item">
            <span class="label">Each Lots</span>
            <span class="value">{{ biInfo.rate_1 }} Lots = {{ biInfo.rate_2 }}
              {{ bi.ename }}</span>
          </div>
          <div class="info-item">
            <span class="label">Estimated Handling Fee</span>
            <span class="value">{{ handlingFee }}</span>
          </div>
          <div class="info-item">
            <span class="label">Estimated Margin</span>
            <span class="value">{{ margin_required }}</span>
          </div>
        </div>

        <div class="d-flex gap-2">
          <button class="btn btn-buy flex-grow-1" @click="submitForm(1)">
            Buy
          </button>
          <button class="btn btn-sell flex-grow-1" @click="submitForm(2)">
            Sell
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BigNumber from "bignumber.js";
import {
  addcontractorder,
  addAutoContractOrder,
  getBiInfo,
} from "@/apis/wallet";
import LoadingOverlay from "./LoadingOverlay.vue";
import { message } from "@/utils/message";
export default {
  props: {
    bi: {
      type: Object,
      default: null,
    },
    biList: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    bi: {
      handler(newVal) {
        if (newVal) {
          this.getBiInfo();
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      loading: false,
      priceType: "Market Price",
      leverage: 1,
      stopLoss: 0,
      stopLossEnabled: false,
      takeProfit: 0,
      takeProfitEnabled: false,
      amount: 0.01,
      price: "",
      biInfo: {
        rate_1: 0,
        rate_2: 0,
        margin_required: 0,
        is_margin_multiplied: 1,
        margin_is_only_price: 0,
        price_margin_ratio: 1,
        amount_per_point: 1,
        //commission:0,
        commission: 0.002,
      },
      balance: 0.00, // 新增余额字段


    };
  },
  computed: {
    userInfo() {
      if (!this.$store.state.isLogin) {
        return { money: 0.00 };
      }
      return this.$store.state.userInfo;
    },
    handlingFee() {
      //return BigNumber(this.biInfo.rate_2).times(this.biInfo.commission).div(100).toString();
      return this.calculateFee(this.margin_required, this.biInfo.commission);
    },
    margin_required() {
      const price = this.priceType === "Market Price" ? this.bi.price : this.price || 0;
      return this.calculateMargin(
        this.amount,          // lots
        100000,   // standardLotUnits this.biInfo.rate_2
        price,                // price
        100,        // leverage
        2,                    // decimalPoints
        this.biInfo.amount_per_point,                    // amountPerPoint
        this.biInfo.is_margin_multiplied,
        this.biInfo.margin_is_only_price, // 保证金只与实时价格有关 1:1
        this.biInfo.price_margin_ratio, // 保证金只与实时价格有关 1:1

      );
      //return BigNumber(this.amount).times(this.biInfo.rate_2).times(this.leverage).toString();
    },
    curBiPrice() {
      const bi = this.biList.find((bi) => bi.bi_id === this.bi.bi_id);
      return bi ? bi.price : 0;
    },
  },
  components: {
    LoadingOverlay,
  },
  created() {
    this.loading = true;
    if (this.$store.state.isLogin) {
      this.$store.dispatch("getUserInfo").finally(() => {
        this.loading = false;
      });
    }
    this.loading = false;

  },
  methods: {
    calculateMargin(lots, standardLotUnits, price, leverage, decimalPoints = 5, amountPerPoint = 1, isMarginMultiplied = true, margin_is_only_price = 0, price_margin_ratio = 1) {
      let margin;
      // 计算保证金需求
      if (isMarginMultiplied) {
        margin = (lots * standardLotUnits * price) / leverage;
      } else {
        margin = (lots * standardLotUnits) / leverage;
      }

      if (margin_is_only_price) {
        margin = (lots * price * price_margin_ratio);
      }

      // 根据小数点位数格式化保证金
      margin = parseFloat(margin.toFixed(decimalPoints));
      return margin;
    },
    //编写一个计算手续费的函数
    calculateFee(margin, feeRate) {
      // 使用 BigNumber 确保精度
      return BigNumber(margin).times(feeRate).toNumber().toFixed(2);
    },

    getBiInfo() {
      getBiInfo({ bi_id: this.bi.bi_id }).then((res) => {
        if (res.code == 0) {
          this.biInfo = res.data;
        }
      });
    },
    decreaseStopLoss() {
      if (this.stopLossEnabled) this.stopLoss--;
    },
    increaseStopLoss() {
      if (this.stopLossEnabled) this.stopLoss++;
    },
    decreaseTakeProfit() {
      if (this.takeProfitEnabled) this.takeProfit--;
    },
    increaseTakeProfit() {
      if (this.takeProfitEnabled) this.takeProfit++;
    },
    decreaseAmount() {
      if (this.amount > 0.01) this.amount = +(this.amount - 0.01).toFixed(2);
    },
    increaseAmount() {
      this.amount = +(this.amount + 0.01).toFixed(2);
    },
    decreaseLeverage() {
      if (this.leverage > 1) {
        this.leverage--;
      }

    },
    increaseLeverage() {
      this.leverage++;
    },
    submitForm(type) {
      const params = {
        bi_id: this.bi.bi_id,
        type: type,
        multiple: this.leverage,
        max_lose_money: 0,
        max_win_money: 0,
        money: this.amount,
        start_money: this.bi.price,
      };

      if (this.priceType == "Pending Orders") {
        if (!this.price) {
          message.error("Please enter the price");
          return;
        }
        params.auto_start_money = this.price;
      }

      if (this.stopLossEnabled) {
        params.max_lose_money = this.stopLoss;
      }
      if (this.takeProfitEnabled) {
        params.max_win_money = this.takeProfit;
      }
      this.submitOrder(this.priceType, params);
    },
    async submitOrder(type, data) {
      this.loading = true;
      try {
        let res;
        if (type === "Market Price") {
          res = await addcontractorder(data);
        } else {
          res = await addAutoContractOrder(data);
        }
        this.loading = false;
        if (res.code == 0) {
          message.success("Order submitted successfully");
          this.$bus.emit("order-submitted", res);

          this.$store.dispatch("getUserInfo");
        }
      } catch (error) {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.market-trade {

  /* 移除 Chrome, Safari, Edge, Opera 的增减按钮 */
  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* 移除 Firefox 的增减按钮 */
  input[type="number"] {
    -moz-appearance: textfield;
  }

  .card {
    border: none;
  }

  .card-title {
    font-size: 1.25rem;
    font-weight: 500;
  }

  .price {
    color: var(--bs-primary);
    font-size: 1.25rem;
    font-weight: 500;
  }

  label {
    font-weight: 500;
    margin-bottom: 0.5rem;
  }

  .input-group {
    .btn {
      min-width: 40px;
      // padding: 0.375rem;

      // &:hover {
      //   background-color: var(--bs-tertiary-bg);
      // }
    }
  }

  .trade-info {
    background-color: var(--bs-tertiary-bg);
    border-radius: 0.375rem;
    padding: 1rem;

    .info-item {
      display: flex;
      justify-content: space-between;
      margin-bottom: 0.5rem;

      &:last-child {
        margin-bottom: 0;
      }

      .label {
        color: var(--bs-secondary-color);
      }

      .value {
        font-weight: 500;
      }
    }
  }

  .btn-buy {
    background-color: #0d6efd;
    color: white;

    &:hover {
      background-color: darken(#0d6efd, 5%);
    }
  }

  .btn-sell {
    background-color: #dc3545;
    color: white;

    &:hover {
      background-color: darken(#dc3545, 5%);
    }
  }

  .balance-box {
    background-color: #007bff;
    /* 底部浅蓝色 */
    border-radius: 8px;
    /* 圆角 */
    padding: 15px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: white;
    /* 文字白色 */
  }

  .balance-label {
    font-size: 16px;
    font-weight: bold;
  }

  .balance-value {
    font-size: 18px;
    font-weight: bold;
  }
}

// 暗色主题适配
.dark {
  .market-trade {
    .card {
      background: #131722;
    }

    .card-title {
      color: #fff;
    }

    .form-group {
      label {
        color: #fff;
      }
    }

    .form-control,
    .form-select,
    .trade-info {
      background-color: #2a2e39;
      border-color: #373b3e;
      color: #fff;
    }
  }
}
</style>
